import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import Recaptcha from 'react-google-invisible-recaptcha';
import { showHideOldNewHeaderFooter, formatNumber } from '../../app-actions';
import {
  stripStartingAndEndingPTags,
  validateNumber,
  validateEmail,
  validateText,
} from '../ssm-homepage/ssm-homepage.actions';
import ViewHeader from '../../components/view-header';
import Loader from '../../components/loader';
import InputFields from './adaptive-mobility-components/input-Fields/input-Fields';
import SubmitSection from './adaptive-mobility-components/submit-section/submit-section';
import InterestInputFields from './adaptive-mobility-components/interest-input-Fields/interest-input-Fields';
import PlanItem from './adaptive-mobility-components/plan-item/plan-item';
import HeaderWithImage from './adaptive-mobility-components/header-with-image/header-with-image';
import DisplayCostAndDataAllowance from './adaptive-mobility-components/display-cost-and-data-allowance/display-cost-and-data-allowance';
import { createOmnitureDataLayerForApps, omnitureTriggerEventAction } from '../../utilities/omniture-data-layer';
import './adaptive-mobility-external.css';
import {
  getDataOnlyPlanRecommendation,
  getVoiceAndDataPlanRecommendation,
  prepareInterestInputFieldsValue,
  validateAllInputFields,
  validatePhoneNumberWithStartLetter,
  getTitleChart,
  preparePostCallData,
  getOptimizeView1,
  getTotalDevices,
  prepareShowResultTrackingData,
} from './adaptive-mobility-external.actions';
import {
  DEBUG_MODE,
  WINDOW_START_POSITION,
} from '../../app-constants';


class AdaptiveMobilityExternalView extends Component {
  state ={
    formSubmittedLoader: false,
    confirminterest: false,
    interestInputFieldsValue: {},
    inValidAllRequiredFeilds: true,
    validateInputFields: {},
    newPlanMapping: [],
    planListData: [],
    positiveBanner: false,
    showResultBtnHide: false,
    calculationView: 'NORMAL',
    optimizeTotalCost: 0,
    optimizeTotalData: 0,
    optimizedPlanMapping: [],
    totalDevices: 0,
    feSolutionFound: false,
    onRequestCallBackPage: false,
    currentTotalCost: 0,
    currentTotalData: 0,
  };

  componentDidMount = () => {
    createOmnitureDataLayerForApps('adaptive-mobility-external', 'Enterprise', 'AdaptiveMobilityExternal', 'calculator');
    window.onpopstate = this.onBrowserBackButtonClicked;
    showHideOldNewHeaderFooter(true); // required again as in the original authorable call, old footer is not available
    this.updateStateData(prepareInterestInputFieldsValue());
    document.title = 'Adaptive Mobility Calculator';
    window.history.scrollRestoration = 'manual';
  }

  onSubmitSiteInterestButton = () => {
    omnitureTriggerEventAction('formStart');
    window.history.pushState({ page: 'submit' }, 'submit');
    this.setState({ confirminterest: true, onRequestCallBackPage: true }, () => {
      window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
    });
    this.setState({ confirminterest: true });
  };

  onSubmitSiteBackButton = () => {
    omnitureTriggerEventAction('formAbandon');
    this.setState({ confirminterest: true }, () => {
      window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
    });
    this.setState({ confirminterest: false });
  };

  onSubmitSiteForm = () => {
    omnitureTriggerEventAction('formSuccess');
    this.recaptcha.execute();
  };

  onSubmitShowResultsTrackingData = () => {
    const trackingSubmitData = prepareShowResultTrackingData(this.state.planListData,
      this.props.authorableContent.recommendation,
      this.props.backendSolutionFound,
      this.props.backendOptimizedPlansWithDevices,
      this.state.feSolutionFound,
      this.state.optimizedPlanMapping,
    );

    if (this.state.onRequestCallBackPage === false) {
      const { submitAMECalculatorTrackingData } = this.props.actions;
      submitAMECalculatorTrackingData(trackingSubmitData);
    }
  };

  onResolved = () => {
    if (DEBUG_MODE) {
      console.log('RESOLVED1', this.recaptcha.getResponse()); // eslint-disable-line
    }
    const gCaptcha = this.recaptcha.getResponse();
    this.setState({ formSubmittedLoader: true });
    const { submitAMECalCulatorData } = this.props.actions;
    const submitData = preparePostCallData(this.state.planListData,
      this.state.interestInputFieldsValue,
      this.props.authorableContent.recommendation,
      gCaptcha,
      this.props.backendSolutionFound,
      this.props.backendOptimizedPlansWithDevices,
      this.state.feSolutionFound,
      this.state.optimizedPlanMapping,
    );
    submitAMECalCulatorData(submitData);
  };

  onError= () => {
    if (DEBUG_MODE) {
      console.log('Facing network error .Please check you internet connection'); // eslint-disable-line
    }
  };

  onExpired= () => {
    if (DEBUG_MODE) {
      console.log('token got expired'); // eslint-disable-line
    }
  };

  onBrowserBackButtonClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.confirminterest) {
      this.returnToCalculationScreen();
    }
  };

  onChangeInputFields = (event) => {
    const selectedValue = event.target.value;
    const type = event.target.id;
    const interestInputFieldsValue = this.state.interestInputFieldsValue;
    if (type === 'phone') {
      if (selectedValue.length < 11 && validateNumber(selectedValue)) {
        interestInputFieldsValue[type] = selectedValue;
      }
    } else {
      interestInputFieldsValue[type] = selectedValue;
    }
    this.setState({ interestInputFieldsValue });
  };

  onChangeDropDown = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    const type = event.target.parentElement.parentElement.id.split('-')[0];
    const interestInputFieldsValue = this.state.interestInputFieldsValue;
    interestInputFieldsValue[type] = selectedValue;
    const validateInputFields = this.state.validateInputFields;
    if (type === 'job' || type === 'seniority') {
      validateInputFields[type] = selectedValue.length === 0;
    }
    const validate = validateAllInputFields(interestInputFieldsValue, this.state.validateInputFields);
    this.setState({ interestInputFieldsValue, inValidAllRequiredFeilds: validate, validateInputFields });
  };

  onBlurInputFields = (event) => {
    const selectedValue = event.target.value;
    const type = event.target.id;
    const validateInputFields = this.state.validateInputFields;
    if (type === 'email') {
      validateInputFields[type] = !validateEmail(selectedValue);
    } else if (type === 'phone') {
      validateInputFields[type] = !validatePhoneNumberWithStartLetter(selectedValue);
    } else if (type === 'firstName' || type === 'lastName') {
      validateInputFields[type] = !validateText(selectedValue);
    } else {
      validateInputFields[type] = (selectedValue.length <= 0);
    }
    this.setState({ validateInputFields }, this.validateAllRequiredFeilds());
  };

  onBlurDropDown = (event) => {
    const type = (event.target.id) ? event.target.id : event.target.parentElement.id;
    const validateInputFields = this.state.validateInputFields;
    const interestInputFieldsValue = this.state.interestInputFieldsValue;
    if (type !== '') {
      validateInputFields[type] = (interestInputFieldsValue[type] === '');
      this.setState({ validateInputFields }, this.validateAllRequiredFeilds());
    }
  };

  onChangeCheckBox = (event) => {
    const interestInputFieldsValue = this.state.interestInputFieldsValue;
    const validateInputFields = this.state.validateInputFields;
    interestInputFieldsValue.submitCheckbox = event.target.checked;
    validateInputFields.submitCheckbox = !event.target.checked;
    this.setState({ interestInputFieldsValue, validateInputFields }, () => {
      this.validateAllRequiredFeilds();
    });
  };

  onHandleCalculationView = (event) => {
    this.setState({ calculationView: event.id });
  }

  returnToCalculationScreen = () => {
    omnitureTriggerEventAction('formAbandon');
    this.setState({ confirminterest: false });
  }

  showResultClickHandler = (planListData) => {
    omnitureTriggerEventAction('formStep');
    const { recommendation } = this.props.authorableContent;
    const optimizedDetails = getOptimizeView1(planListData, recommendation);
    console.log('fe optimzer');
    console.log(optimizedDetails);
    const totalDevices = getTotalDevices(planListData);
    this.setState({ planListData, totalDevices, onRequestCallBackPage: false });

    let currentTotalCost = 0;
    let currentTotalData = 0;
    let recommendedTotalCost = 0;
    let recommendedTotalData = 0;
    const recommendedPlans = [];
    const planDetails = [];

    const newPlanMapping = planListData.map((originalPlan) => {
      const planText = originalPlan.id.split('-')[0];
      const originalPlanId = `${planText} ${getTitleChart(originalPlan.index)}`;
      const planCost = parseInt(originalPlan.cost, 10);
      const planDataAllowance = parseInt(originalPlan.dataAllowance, 10);
      const numberOfDevices = parseInt(originalPlan.numberOfDevices, 10);
      let newPlanName = '';
      if (originalPlan.dataOnly === 'Yes') {
        newPlanName = getDataOnlyPlanRecommendation(planCost, planDataAllowance);
      } else {
        newPlanName = getVoiceAndDataPlanRecommendation(planCost, planDataAllowance);
      }

      currentTotalCost += planCost * numberOfDevices;
      currentTotalData += planDataAllowance * numberOfDevices;
      recommendedTotalCost += parseInt(recommendation[newPlanName].voiceCost, 10) * numberOfDevices;
      recommendedTotalData += parseInt(recommendation[newPlanName].dataCost, 10) * numberOfDevices;
      recommendedPlans.push(recommendation[newPlanName].title);
      planDetails.push({
        userPlanName: originalPlanId,
        numberOfDevices,
        cost: planCost,
        data: planDataAllowance,
        dataOnly: originalPlan.dataOnly,
      });

      return {
        originalPlanId,
        numberOfDevices: parseInt(originalPlan.numberOfDevices, 10),
        cost: recommendation[newPlanName].voiceCost,
        dataAllowance: recommendation[newPlanName].dataCost,
        newPlanName,
      };
    });

    const optimizedPlans = optimizedDetails.finalOptimizedPlans.map((optimizePlan, index) => (
      {
        totalDevicesText: optimizePlan.planTitle,
        optimizePlanName: optimizePlan.planName,
        keyValue: `${optimizePlan.planName}-${index + 1}`,
        totalDevices: optimizePlan.planDevices,
      }
    ));

    const finalOptimizedTotalCostInitialValue = 0;
    const finalOptimizedTotalCost = optimizedDetails.finalOptimizedPlans
      .reduce((accumulator, currentValue) => accumulator + currentValue.planVoiceCost, finalOptimizedTotalCostInitialValue);

    const finalOptimizedTotalDataInitialValue = 0;
    const finalOptimizedTotalData = optimizedDetails.finalOptimizedPlans
      .reduce((accumulator, currentValue) => accumulator + currentValue.planDataCost, finalOptimizedTotalDataInitialValue);

    const prepareShowResultPostData = {
      currentTotalCost,
      currentTotalData,
      recommendedTotalCost,
      recommendedTotalData,
      planDetails,
    };

    const { submitAMEShowData } = this.props.actions;
    submitAMEShowData(prepareShowResultPostData);

    const newPlanMappingMatch = newPlanMapping.filter(planItem => planItem.newPlanName !== 'noPlanFound');
    const newPlanMappingNoMatch = newPlanMapping.filter(planItem => planItem.newPlanName === 'noPlanFound');

    const finalSortedPlanMapping = [...newPlanMappingMatch, ...newPlanMappingNoMatch];

    this.setState({
      newPlanMapping: finalSortedPlanMapping,
      positiveBanner: newPlanMappingMatch.length > 0,
      showResultBtnHide: true,
      optimizeTotalCost: finalOptimizedTotalCost,
      optimizeTotalData: finalOptimizedTotalData,
      optimizedPlanMapping: optimizedPlans,
      feSolutionFound: optimizedDetails.solutionFound,
      currentTotalCost,
      currentTotalData,
    });
  };

  clearResult = () => {
    this.setState({
      newPlanMapping: [],
      showResultBtnHide: false,
      calculationView: 'NORMAL',
      feSolutionFound: false,
      onRequestCallBackPage: false,
    });
  };

  validateAllRequiredFeilds = () => {
    const validate = validateAllInputFields(this.state.interestInputFieldsValue, this.state.validateInputFields);
    this.setState({ inValidAllRequiredFeilds: validate });
  };

  updateStateData = (defaultData, callbackfunction) => {
    this.setState(defaultData, callbackfunction);
  };

  render() {
    if (this.props.dataLoaded && this.props.formSubmitted === false && this.state.confirminterest === false) {
      const {
        planCalculator: {
          mainImage,
          headingText,
          description,
          planErrorMessage,
          formFields: {
            cost,
            allowance,
            devices,
            usage,
            dataOnly,
          },
        },
        planDetails,
        explanationSection: {
          description: descriptionText,
          interestButtonText,
        },
        recommendation,
      } = this.props.authorableContent;

      const inputFieldsAuthorableContent = {
        cost,
        allowance,
        devices,
        usage,
        dataOnly,
        planDetails,
        planErrorMessage,
      };

      const explanationSectionAuthorable = {
        descriptionText,
        ButtonText: interestButtonText,
      };

      const newCostsAndDataAuthorableContent = {
        totalCostText: recommendation.totalCostText,
        totalDataText: recommendation.totalDataText,
        gbText: planDetails.gbText,
        saveText: recommendation.saveText,
        forText: recommendation.forText,
        extraDataText: recommendation.extraDataText,
        getText: recommendation.getText,
        submitButtonText: interestButtonText,
      };

      const suggestedPlans = this.state.newPlanMapping.map(planItem => (
        <PlanItem
          key={planItem.originalPlanId}
          item={recommendation[planItem.newPlanName]}
          customClass="plan-test-class"
          noPlanFound={planItem.newPlanName === 'noPlanFound'}
          planTitle={`${planItem.originalPlanId} - ${formatNumber(planItem.numberOfDevices)} devices`}
        />
      ));


      const optimizedPlans = this.state.optimizedPlanMapping.filter(plan => plan.totalDevices > 0).map(planItem => (
        <PlanItem
          key={planItem.keyValue}
          item={recommendation[planItem.optimizePlanName]}
          customClass="plan-test-class"
          noPlanFound={planItem.optimizePlanName === 'noPlanFound'}
          planTitle={planItem.totalDevicesText}
        />
      ));

      const backendOptimizedPlans = this.props.backendOptimizedPlansWithDevices && this.props.backendOptimizedPlansWithDevices.map(backendPlan => (
        <PlanItem
          key={backendPlan.planName}
          item={recommendation[backendPlan.planName]}
          customClass="plan-test-class"
          noPlanFound={backendPlan.planName === 'noPlanFound'}
          planTitle={backendPlan.totalDevicesText}
        />
      ));

      const backEndOptimizedTotalCostInitialValue = 0;
      const backEndOptimizedTotalCost = this.props.backendOptimizedPlansWithDevices && this.props.backendOptimizedPlansWithDevices
        .reduce((accumulator, currentValue) => accumulator +
        (parseInt(recommendation[currentValue.planName].voiceCost, 10) * currentValue.devicesCount), backEndOptimizedTotalCostInitialValue);

      const backEndOptimizedTotalDataInitialValue = 0;
      const backEndOptimizedTotalData = this.props.backendOptimizedPlansWithDevices && this.props.backendOptimizedPlansWithDevices
        .reduce((accumulator, currentValue) => accumulator +
      (parseInt(recommendation[currentValue.planName].dataCost, 10) * currentValue.devicesCount), backEndOptimizedTotalDataInitialValue);


      const { newPlanMapping, positiveBanner } = this.state;
      const saveMoney = (this.props.backendSolutionFound) ? this.state.currentTotalCost - backEndOptimizedTotalCost :
        this.state.currentTotalCost - this.state.optimizeTotalCost;
      const extraData = (this.props.backendSolutionFound) ? backEndOptimizedTotalData - this.state.currentTotalData :
        this.state.optimizeTotalData - this.state.currentTotalData;

      return (
        <div className="adaptive-mobility-external root-container container body18">
          <HeaderWithImage
            title={headingText}
            text={description}
            image={mainImage}
          />
          <InputFields
            authorableContent={inputFieldsAuthorableContent}
            inputLimit={6}
            showResultClickHandler={this.showResultClickHandler}
            clearResults={this.clearResult}
            planListData={this.state.planListData}
            showResultBtnHide={this.state.showResultBtnHide}
            calculationInProgress={this.props.calculationInProgress}
          />

          {newPlanMapping.length > 0 && this.props.calculationInProgress === false &&
            <div className="result-section paddingS pb-0 pl-0 pr-0">
              <div className="heading44 paddingXS pt-0 pl-0 pr-0">{recommendation.recommendationHeading}</div>

              <div className="paddingXS pl-0 pr-0">
                <GenericAlert
                  name="primary-title"
                  description={positiveBanner ? recommendation.positiveBanner : recommendation.negativeBanner}
                  showBackground
                />
              </div>
              {this.props.backendSolutionFound === false && this.state.feSolutionFound === false &&
                <DisplayCostAndDataAllowance
                  authorableContent={newCostsAndDataAuthorableContent}
                  planListData={this.state.newPlanMapping}
                  recommendSection
                  requestCallBackBtn
                  explanationSectionAuthorable={explanationSectionAuthorable}
                  onSubmitButton={this.onSubmitSiteInterestButton}
                  currentTotalCost={this.state.currentTotalCost}
                  currentTotalData={this.state.currentTotalData}
                />
              }
              {this.props.backendSolutionFound === false && this.state.feSolutionFound === false &&
                <div className="row new-plans">
                  {suggestedPlans}
                  {this.onSubmitShowResultsTrackingData()}
                </div>
              }
              {this.props.backendSolutionFound === false && this.state.feSolutionFound &&
                <DisplayCostAndDataAllowance
                  authorableContent={newCostsAndDataAuthorableContent}
                  planListData={this.state.newPlanMapping}
                  recommendSection
                  optimize
                  optimizeTotalCost={this.state.optimizeTotalCost}
                  optimizeTotalData={this.state.optimizeTotalData}
                  requestCallBackBtn
                  saveMoney={saveMoney}
                  dataBenefit={extraData}
                  explanationSectionAuthorable={explanationSectionAuthorable}
                  onSubmitButton={this.onSubmitSiteInterestButton}
                />
              }
              {this.props.backendSolutionFound === false && this.state.feSolutionFound &&
                <div className="row new-plans">
                  {optimizedPlans}
                  {this.onSubmitShowResultsTrackingData()}
                </div>
              }

              {this.state.totalDevices <= 250 && this.props.backendSolutionFound &&
                <DisplayCostAndDataAllowance
                  authorableContent={newCostsAndDataAuthorableContent}
                  planListData={this.state.newPlanMapping}
                  recommendSection
                  optimize
                  optimizeTotalCost={backEndOptimizedTotalCost}
                  optimizeTotalData={backEndOptimizedTotalData}
                  requestCallBackBtn
                  saveMoney={saveMoney}
                  dataBenefit={extraData}
                  explanationSectionAuthorable={explanationSectionAuthorable}
                  onSubmitButton={this.onSubmitSiteInterestButton}
                />
              }

              {this.state.totalDevices <= 250 && this.props.backendSolutionFound &&
                <div className="row new-plans">
                  {backendOptimizedPlans}
                  {this.onSubmitShowResultsTrackingData()}
                </div>
              }

              <div className="calculation-submit">
                <SubmitSection
                  authorableContent={explanationSectionAuthorable}
                  onSubmitButton={this.onSubmitSiteInterestButton}
                  positiveBanner={this.state.positiveBanner}
                />
              </div>
            </div>
          }
        </div>
      );
    } else if (this.props.dataLoaded && this.state.confirminterest && this.props.formSubmitted === false) {
      const {
        interestSection,
        interestSection: {
          headingText,
        },
        planCalculator: {
          formFields: {
            firstName,
            lastName,
            email,
            phone,
            company,
            job,
            seniority,
            industry,
            country,
            companySize,
            preferredContactTime,
          },
        },
        submitSection: {
          submitButtonText,
          checkBoxLabel,
          backButtonText,
        },
      } = this.props.authorableContent;

      const initialHeader = {
        heading: headingText,
      };

      const inputFieldsAuthorableContent = {
        firstName,
        lastName,
        email,
        phone,
        company,
        job,
        seniority,
        industry,
        country,
        companySize,
        preferredContactTime,
        interestSection,
      };
      const submitSectionAuthorable = {
        checkBoxLabel,
        ButtonText: submitButtonText,
        backButtonText,
      };

      return (
        <div className="adaptive-mobility-external root-container container body18  request-page">
          <ViewHeader content={initialHeader} customOverrideClass="heading24" productError />
          <InterestInputFields
            authorableContent={inputFieldsAuthorableContent}
            interestInputFieldsValue={this.state.interestInputFieldsValue}
            validateInputFields={this.state.validateInputFields}
            onChangeDropDown={this.onChangeDropDown}
            onChangeInputFields={this.onChangeInputFields}
            onBlurInputFields={this.onBlurInputFields}
            onBlurDropDown={this.onBlurDropDown}
          />
          <SubmitSection
            authorableContent={submitSectionAuthorable}
            onSubmitButton={this.onSubmitSiteForm}
            onChangCheckBox={this.onChangeCheckBox}
            checkBoxState={this.state.interestInputFieldsValue.submitCheckbox}
            submitLoader={this.state.formSubmittedLoader}
            submitBtnDisabled={this.state.inValidAllRequiredFeilds}
            onBackButton={this.onSubmitSiteBackButton}
            backButton
          />
          <Recaptcha
            ref={(ref) => { this.recaptcha = ref; }}
            sitekey="6Lc4EygUAAAAAARbXitF8Ce5SDM-mPst4SZV8Tbd"
            onResolved={this.onResolved}
            onError={this.onError}
            onExpired={this.onExpired}
          />

        </div>
      );
    } else if (this.props.dataLoaded && this.props.formSubmitted) {
      const {
        confirmation: {
          heading,
          description,
        },
      } = this.props.authorableContent;
      const headingWithReferenceNumber = `${heading}`;
      const confirmationHeader = {
        heading: headingWithReferenceNumber,
        description: renderHTML(stripStartingAndEndingPTags(description)),
      };
      window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
      return (
        <div className="adaptive-mobility-external root-container container confirm-page body18">
          <ViewHeader content={confirmationHeader} customOverrideClass="heading40" productError />
        </div>
      );
    }
    return <Loader />;
  }
}
export default AdaptiveMobilityExternalView;
